import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError, shareReplay} from 'rxjs/operators';

import {SASEUNG3_STATS_API_URL} from '../../defines/protocol';
import {ApiService} from '../api/api.service';

export interface Saseung3Stats {
  character_total_count: number;
  tone_marked_character_count: number;
}

export const SASEUNG3_STATS_FALLBACK: Saseung3Stats = {
  character_total_count: 16435,
  tone_marked_character_count: 3990,
};

@Injectable({
  providedIn: 'root',
})
export class Saseung3StatsService {
  private cache$: Observable<Saseung3Stats> | null = null;

  constructor(
    private api: ApiService,
  ) {
  }

  Get(): Observable<Saseung3Stats> {
    if (!this.cache$) {
      // catchError가 shareReplay 앞에 있어 일시 장애로 fallback이 한번 캐시되면 세션 동안 유지된다.
      // 사 성 옥편 도움말은 단발 호출이라 새로고침 전까지 fallback 표시를 허용.
      this.cache$ = this.api.Get(SASEUNG3_STATS_API_URL).pipe(
        catchError((err) => {
          console.error('Saseung3StatsService::Get()', err);
          return of(SASEUNG3_STATS_FALLBACK);
        }),
        shareReplay(1),
      );
    }
    return this.cache$;
  }
}
